import React, { useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import FieldBankList from './List';
import FieldBankNew from './New';
import FieldBankDetails, { EditField } from './Details';
import { FieldBankProvider } from './context';
import { AppContext } from 'views/App/context';

export default function FieldBank() {
  const { hasAppPermission } = useContext(AppContext);

  return (
    <Routes>
      <Route
        index
        element={<FieldBankList />}
      />
      <Route
        path='new'
        element={<FieldBankNew />}
      />
      <Route
        path=':id'
        element={<FieldBankDetails />}
      />
      <Route
        path=':id/edit'
        element={
          <FieldBankProvider>
            <EditField />
          </FieldBankProvider>
        }
      />
      <Route
        path='*'
        element={
          <Navigate
            to='/admin/performance-reporting/field-bank'
            replace
          />
        }
      />
    </Routes>
  );
}
